import React, { useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import useAsyncEffect from 'use-async-effect';
import api, { combinedTicker } from '../../api/api';

interface IAutoCompleteItem {
    id:string
    name:string
    combinedTicker:string
    companyName:string
}

interface IProps {
    onAdd: (item: IAutoCompleteItem) => void
    buttonClassName?: string
}

const ChooseCompanySelect:React.FC<IProps> = ({ onAdd, buttonClassName }) => {

    const [ items, setItems ] = useState<IAutoCompleteItem[]>([]);
    const [ selectedItem, setSelectedItem ] = useState<IAutoCompleteItem|undefined>(undefined);

    useAsyncEffect(async (isMounted)=>{
        const stocks = await api().getStockNames();
        if(isMounted()){
            const arr:IAutoCompleteItem[] = stocks.map(x=>({
                id: x.id,
                name: combinedTicker(x.ticker, x.exchange)+ ' ' + x.companyName,
                combinedTicker: combinedTicker(x.ticker, x.exchange),
                companyName: x.companyName
            }));
            setItems(arr)
        }
    }, []);

    const handleOnSelect = (e:IAutoCompleteItem) => {
        if(e){
            const item:IAutoCompleteItem = items.find(x=>x.id===e.id)!;
            setSelectedItem(item);
        }
        else{
            setSelectedItem(undefined)
        }
    }

    const add = async ()=>{
        if(selectedItem){
            onAdd(selectedItem);
        }else{
            alert('Please select a Company')
        }
    }

    return <div className='add-row'>
        <button className={buttonClassName || 'add-row-button'} onClick={add} >Add Row</button>
        <div style={{width:'350px'}}><ReactSearchAutocomplete
            styling={{ fontSize: "16px", borderRadius: '0'}}
            items={items}
            onSelect={handleOnSelect}
            placeholder='Choose Company'
            fuseOptions={{threshold: 0, ignoreLocation: true}}
        /></div>
    </div>
}

export default ChooseCompanySelect;
